/* eslint-disable no-await-in-loop */
/* eslint-disable no-continue */
/* eslint-disable no-plusplus */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
/* eslint-disable indent */
/* eslint-disable no-trailing-spaces */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-this-in-sfc */
import React, { useEffect, useState, useCallback, useMemo, useRef, useContext } from 'react';
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  Col,
  Collapse,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  UncontrolledTooltip,
} from 'reactstrap';

import { addMonths, format, getDate, getMonth, getYear, isAfter } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';
import { range } from 'lodash';
import * as Yup from 'yup';

import Calendar from '../../components/Calendar';
import DatePickerMaskedInput from '../../components/DatePickerMaskedInput';
import Notification from '../../components/Notification';
import TableManager from '../../components/TableManager';
import TimePickerMaskedInput from '../../components/TimePickerMaskedInput';
import { AppContext } from '../../contexts/app';
import { useManager } from '../../hooks/manager';
import useSocket from '../../hooks/useSocket';
import api from '../../services/api';

function SalaAtendimentos() {
  const notificationRef = useRef();
  const { setLoading } = useContext(AppContext);
  const { socket, socketId } = useSocket();
  const [validationErrors, setValidationErrors] = useState({});
  const { load, destroy, update, store } = useManager();
  const [showCloseSalaAtendimentoModal, setShowCloseSalaAtendimentoModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showDisponibilidade, setShowDisponibilidade] = useState(false);
  const [showHoraDisponibilidade, setShowHoraDisponibilidade] = useState(false);
  const [id, setId] = useState();
  const [disponibilidadeId, setDisponibilidadeId] = useState();
  const [nome, setNome] = useState('');
  const [quantidadeVagas, setQuantidadeVagas] = useState('');
  const [disponibilidade, setDisponibilidade] = useState([]);
  const [dataInicio, setDataInicio] = useState('');
  const [dataTermino, setDataTermino] = useState('');
  const [horaInicio, setHoraInicio] = useState('');
  const [horaTermino, setHoraTermino] = useState('');
  const [dataCloseSalaAtendimentoInicio, setDataCloseSalaAtendimentoInicio] = useState('');
  const [dataCloseSalaAtendimentoTermino, setDataCloseSalaAtendimentoTermino] = useState('');
  const [newOrUpdateHoraInicio, setNewOrUpdateHoraInicio] = useState('');
  const [newOrUpdateHoraTermino, setNewOrUpdateHoraTermino] = useState('');
  const [daysOfCalendar, setDaysOfCalendar] = useState([]);
  const [showLoteProgressModal, setShowLoteProgressModal] = useState(false);
  const [loteProgress, setLoteProgress] = useState(null);
  const [isLoteUpdating, setIsLoteUpdating] = useState(false);
  const [loteJobId, setLoteJobId] = useState(null);
  const [disponibilidadeVersion, setDisponibilidadeVersion] = useState(0);
  const [showSkippedDetails, setShowSkippedDetails] = useState(false);

  useEffect(() => {
    load('/salaAtendimentos', 1, []);
  }, [load]);

  useEffect(() => {
    (async () => {
      try {
        if (showDisponibilidade) {
          setLoading(true);
          const firstDayOfCalendar = daysOfCalendar[0];
          const lastDayOfCalendar = daysOfCalendar[daysOfCalendar.length - 1];

          if (firstDayOfCalendar && lastDayOfCalendar) {
            const response = await api.get(`/salaAtendimentoDisponibilidades/${id}?dataHoraInicio=${firstDayOfCalendar}&dataHoraTermino=${lastDayOfCalendar}`);
            setDisponibilidade(response.data);
          }
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        console.log(error);
      }
    })();
  }, [daysOfCalendar, showDisponibilidade, disponibilidadeVersion]);

  useEffect(() => {
    (async () => {
      const response = await api.get('/salaAtendimentoDisponibilidadesFirstDateAndLastDateClosed');
      console.log('🚀 ~ response:', response.data);
      if (response?.data?.firstDate?.dataHoraInicio && response?.data?.lastDate?.dataHoraTermino) {
        setDataCloseSalaAtendimentoInicio(new Date(response.data.firstDate.dataHoraInicio));
        setDataCloseSalaAtendimentoTermino(new Date(response.data.lastDate.dataHoraTermino));
      }
    })();
  }, []);

  useEffect(() => {
    if (!socket || (!isLoteUpdating && !loteJobId)) {
      return undefined;
    }

    const matchesJob = (payload) => !loteJobId || !payload?.jobId || payload.jobId === loteJobId;

    const onProgress = (payload) => {
      if (!matchesJob(payload)) {
        return;
      }
      setLoteProgress(payload);
    };

    const onCompleted = (payload) => {
      if (!matchesJob(payload)) {
        return;
      }
      setLoteProgress(payload);
      setIsLoteUpdating(false);
      setDisponibilidadeVersion((version) => version + 1);
      notificationRef.current.notify({
        message: payload?.updated
          ? 'Horários da sala de atendimento alterados com sucesso'
          : 'Nenhum horário existente foi alterado no período informado',
        color: payload?.updated ? 'success' : 'warning',
      });
    };

    const onError = (payload) => {
      if (!matchesJob(payload)) {
        return;
      }
      setLoteProgress({ ...payload, status: 'error' });
      setIsLoteUpdating(false);
      notificationRef.current.notify({
        message: payload?.message || 'Falha ao alterar os horários do período',
        color: 'danger',
      });
    };

    socket.on('salaAtendimentoDisponibilidade:progress', onProgress);
    socket.on('salaAtendimentoDisponibilidade:completed', onCompleted);
    socket.on('salaAtendimentoDisponibilidade:error', onError);

    return () => {
      socket.off('salaAtendimentoDisponibilidade:progress', onProgress);
      socket.off('salaAtendimentoDisponibilidade:completed', onCompleted);
      socket.off('salaAtendimentoDisponibilidade:error', onError);
    };
  }, [socket, loteJobId, isLoteUpdating]);

  const handleUpdate = useCallback((data) => {
    setValidationErrors({});
    setId(data._id);
    setNome(data.nome);
    setQuantidadeVagas(data.quantidadeVagas);
    setShowModal(true);
  }, []);

  const handleCreate = useCallback(() => {
    setValidationErrors({});
    setId(null);
    setNome('');
    setQuantidadeVagas('');
    setShowModal(true);
  }, []);

  const handleShowDisponibilidade = useCallback((salaAtendimento) => {
    setId(salaAtendimento._id);
    setNome(salaAtendimento.nome);
    setShowDisponibilidade(true);
  }, []);

  const handleShowHoraDisponibilidade = useCallback((d) => {
    if (!d?._id) {
      return;
    }

    setDisponibilidadeId(d._id);
    setNewOrUpdateHoraInicio(d?.dataHoraInicio ? new Date(d.dataHoraInicio) : '');
    setNewOrUpdateHoraTermino(d?.dataHoraTermino ? new Date(d.dataHoraTermino) : '');
    setValidationErrors({});
    setShowHoraDisponibilidade(true);
  }, []);

  const handleUpdateDisponibilidade = useCallback(() => {
    (async () => {
      try {
        const data = {
          horaInicio: newOrUpdateHoraInicio,
          horaTermino: newOrUpdateHoraTermino,
        };

        const schema = Yup.object().shape({
          horaInicio: Yup.string().required('Informe a hora de início'),
          horaTermino: Yup.string().required('Informe a hora de término'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        const res = await api.put(`/salaAtendimentoDisponibilidades/${disponibilidadeId}`, data);

        setDisponibilidade((d) => [
          res.data,
          ...d.filter((value) => (value.id || value._id) !== disponibilidadeId),
        ]);

        notificationRef.current.notify({
          message: 'Disponibilidade da sala de atendimento alterado com sucesso',
        });

        setShowHoraDisponibilidade(false);
      } catch (err) {
        console.log(err);
        setValidationErrors({});
        if (err instanceof Yup.ValidationError) {
          notificationRef.current.notify({
            message: 'Precisa informar os campos necessários para salvar',
            color: 'warning',
          });
          const ve = {};
          err.inner.forEach((e) => {
            ve[e.path] = e.message;
          });
          setValidationErrors(ve);
          return;
        }

        if (err && err.response && err.response.data) {
          const { message } = err.response.data;

          if (message) {
            notificationRef.current.notify({
              message,
              color: 'danger',
            });

            return;
          }
        }

        notificationRef.current.notify({
          message: 'Falha ao tentar salvar data hora selecionadas',
          color: 'danger',
        });
      }
    })();
  }, [disponibilidadeId, newOrUpdateHoraInicio, newOrUpdateHoraTermino]);

  const handleUpdateDisponibilidadeByPeriod = useCallback(() => {
    (async () => {
      try {
        const validationData = {
          dataInicio,
          dataTermino,
          horaInicio,
          horaTermino,
        };

        const schema = Yup.object().shape({
          dataInicio: Yup.string().required('Informe a data de início'),
          dataTermino: Yup.string()
            .required('Informe a data de término')
            .test(
              'max-12-months',
              'O período não pode ser superior a 12 meses',
              function testPeriod(value) {
                const { dataInicio: inicio } = this.parent;
                if (!inicio || !value) {
                  return true;
                }
                return !isAfter(new Date(value), addMonths(new Date(inicio), 12));
              },
            ),
          horaInicio: Yup.string().required('Informe a hora de início'),
          horaTermino: Yup.string().required('Informe a hora de término'),
        });

        await schema.validate(validationData, {
          abortEarly: false,
        });

        setShowLoteProgressModal(true);
        setIsLoteUpdating(true);
        setLoteJobId(null);
        setShowSkippedDetails(false);
        setLoteProgress({
          status: 'progress',
          total: 0,
          updated: 0,
          skipped: 0,
          message: 'Iniciando alteração dos horários...',
        });

        const res = await api.put(`/salaAtendimentoDisponibilidadesByPeriod/${id}`, {
          dataInicio,
          dataTermino,
          horaInicio,
          horaTermino,
          socketId,
        });

        if (res.status === 202) {
          setLoteJobId(res.data.jobId);
          setLoteProgress((prev) => ({
            ...prev,
            ...res.data,
            status: 'progress',
          }));
          return;
        }

        setLoteProgress({
          status: 'completed',
          ...res.data,
          message: res.data.updated
            ? 'Horários alterados com sucesso'
            : 'Nenhum horário existente foi alterado no período informado',
        });
        setIsLoteUpdating(false);
        setDisponibilidadeVersion((version) => version + 1);

        if (!res.data?.updated) {
          notificationRef.current.notify({
            message: 'Nenhum horário existente foi alterado no período informado',
            color: 'warning',
          });
          return;
        }

        notificationRef.current.notify({
          message: 'Horários da sala de atendimento alterados com sucesso',
        });
      } catch (err) {
        setIsLoteUpdating(false);
        console.log(err);
        setValidationErrors({});
        if (err instanceof Yup.ValidationError) {
          setShowLoteProgressModal(false);
          notificationRef.current.notify({
            message: 'Precisa informar os campos necessários para alterar os horários',
            color: 'warning',
          });
          const ve = {};
          err.inner.forEach((e) => {
            ve[e.path] = e.message;
          });
          setValidationErrors(ve);
          return;
        }

        const message = err?.response?.data?.message || 'Falha ao tentar alterar os horários do período';
        setLoteProgress((prev) => ({
          ...(prev || {}),
          status: 'error',
          message,
        }));

        if (err && err.response && err.response.data) {
          if (err.response.data.message) {
            notificationRef.current.notify({
              message: err.response.data.message,
              color: 'danger',
            });

            return;
          }
        }

        notificationRef.current.notify({
          message: 'Falha ao tentar alterar os horários do período',
          color: 'danger',
        });
      }
    })();
  }, [id, dataInicio, dataTermino, horaInicio, horaTermino, socketId]);

  const handleCloseSalaAtendimento = useCallback(() => {
    (async () => {
      try {
        const validationData = {
          dataCloseSalaAtendimentoInicio,
          dataCloseSalaAtendimentoTermino,
        };

        const schema = Yup.object().shape({
          dataCloseSalaAtendimentoInicio: Yup.string().required('Informe a data de início'),
          dataCloseSalaAtendimentoTermino: Yup.string().required('Informe a data de término'),
        });

        await schema.validate(validationData, {
          abortEarly: false,
        });
        setLoading(true);

        const data = {
          dataInicio: dataCloseSalaAtendimentoInicio,
          dataTermino: dataCloseSalaAtendimentoTermino,
        };

        await api.put('/salaAtendimentoDisponibilidadesClose', data);
        setLoading(false);
        notificationRef.current.notify({
          message: 'Salas fechadas com sucesso',
        });
      } catch (err) {
        setLoading(false);
        console.log(err);
        setValidationErrors({});
        if (err instanceof Yup.ValidationError) {
          notificationRef.current.notify({
            message: 'Por favor, preencha todos os dados necessários para salvar',
            color: 'warning',
          });
          const ve = {};
          err.inner.forEach((e) => {
            ve[e.path] = e.message;
          });
          setValidationErrors(ve);
          return;
        }

        if (err && err.response && err.response.data) {
          const { message } = err.response.data;
          notificationRef.current.notify({
            message,
            color: 'danger',
          });

          return;
        }

        notificationRef.current.notify({
          message: 'Algo inesperado aconteceu e não foi possível salvar',
          color: 'danger',
        });
      }
    })();
  }, [dataCloseSalaAtendimentoInicio, dataCloseSalaAtendimentoTermino]);

  const handleSave = async () => {
    try {
      const data = {
        nome,
        quantidadeVagas,
      };

      const schema = Yup.object().shape({
        nome: Yup.string().required('Informe o nome da sala de atendimento'),
        quantidadeVagas: Yup.string().required('Informe o número da quantidade de vagas da sala'),
      });

      await schema.validate(data, {
        abortEarly: false,
      });

      if (id) {
        update(id, '/salaAtendimentos', data, (salaAtendimento) => {
          setNome(salaAtendimento.nome);
          setLoading(false);
          setShowModal(false);
        }, () => setLoading(false));
        return;
      }

      store('/salaAtendimentos', data, (salaAtendimento) => {
        setId(salaAtendimento._id);
        setNome(salaAtendimento.nome);
        setLoading(false);
        setShowModal(false);
      }, () => setLoading(false));
    } catch (err) {
      setLoading(false);
      console.log(err);
      setValidationErrors({});
      if (err instanceof Yup.ValidationError) {
        notificationRef.current.notify({
          message: 'Por favor, preencha todos os dados necessários para salvar',
          color: 'warning',
        });
        const ve = {};
        err.inner.forEach((e) => {
          ve[e.path] = e.message;
        });
        setValidationErrors(ve);
        return;
      }

      if (err && err.response && err.response.data) {
        const { message } = err.response.data;
        notificationRef.current.notify({
          message,
          color: 'danger',
        });

        return;
      }

      notificationRef.current.notify({
        message: 'Algo inesperado aconteceu e não foi possível salvar',
        color: 'danger',
      });
    }
  };

  const columns = useMemo(() => [
    {
      dataField: 'nome',
      text: 'Nome',
      textFilter: true,
    },
    {
      dataField: 'quantidadeVagas',
      text: 'Quantidade de Vagas',
      textFilter: true,
    },
  ]);

  const actions = useMemo(
    () => [
      {
        name: 'show-disponibilidade',
        tooltip: 'Gerenciar disponibilidade',
        color: 'warning',
        className: 'mt-2 mr-2 text-white',
        icon: 'fas fa-calendar',
        onClick: (row) => handleShowDisponibilidade(row),
      },
    ],
    [handleShowDisponibilidade],
  );

  const renderDayContents = useCallback((dateValue) => {
    const disponibilidadeFilter = disponibilidade.filter(
      (d) => (getDate(new Date(d.dataHoraInicio)) === getDate(dateValue)
        && getMonth(new Date(d.dataHoraInicio)) === getMonth(dateValue)
        && getYear(new Date(d.dataHoraInicio)) === getYear(dateValue)
      ),
    );
    if (disponibilidadeFilter.length > 0) {
      return (
        <>
          <span>{dateValue ? format(dateValue, 'dd', { locale: ptBR }) : ''}</span>
          <div className="position-relative">
            <div
              className="d-flex flex-wrap"
              style={{
                position: 'absolute',
                top: '-18px',
                left: '-55px',
                width: 'max-content',
                height: '35px',
              }}
            >
              {disponibilidadeFilter.map((event) => (
                <div key={event._id}>
                  <UncontrolledTooltip target={`calendar-event-${event._id}`}>
                    {`${event?.dataHoraInicio ? format(new Date(event.dataHoraInicio), 'HH:mm', { locale: ptBR }) : 'Sem Data Hora de Início'} - ${event?.dataHoraTermino ? format(new Date(event.dataHoraTermino), 'HH:mm', { locale: ptBR }) : 'Sem Data Hora de Término'}`}
                  </UncontrolledTooltip>
                  <Button
                    className="p-0"
                    color="link"
                    id={`calendar-event-${event._id}`}
                    onClick={() => handleShowHoraDisponibilidade(event)}
                  >
                    <i className="fas fa-circle text-primary" />
                  </Button>
                </div>
              ))}
            </div>
          </div>
        </>
      );
    }

    return dateValue ? format(dateValue, 'dd', { locale: ptBR }) : '';
  }, [disponibilidade, handleShowHoraDisponibilidade]);

  return (
    <Container fluid>
      <Row className="mt-5">
        <Col>
          <Notification ref={notificationRef} />
          <Card>
            <CardBody>
              <Row>
                <Col>
                  <h3>Salas de Atendimentos</h3>
                </Col>
              </Row>
            </CardBody>
            <CardFooter>
              <Row>
                <Col>
                  <Row>
                    <Col xs={12} sm={5} md={3} className="mb-3 mb-xl-0">
                      <Button block color="success" onClick={handleCreate}>
                        Cadastrar
                      </Button>
                    </Col>
                    <Col xs={12} sm={5} md={3} className="mb-3 mb-xl-0">
                      <Button block color="danger" onClick={() => setShowCloseSalaAtendimentoModal(true)}>
                        Fechar Salas de Atendimento
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </CardFooter>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          <TableManager
            initialColumns={columns}
            actions={actions}
            onUpdate={(row) => handleUpdate(row)}
            onDelete={(row) => destroy(row._id, '/salaAtendimentos')}
          />
        </Col>
      </Row>
      <Modal
        isOpen={showHoraDisponibilidade}
        toggle={() => setShowHoraDisponibilidade(!showHoraDisponibilidade)}
        centered
      >
        <ModalHeader>
          <strong>
            {`Alterar a disponibilidade do dia ${newOrUpdateHoraInicio ? format(newOrUpdateHoraInicio, 'dd/MM/yyyy') : 'não definido'}`}
          </strong>
          <Button
            className="close position-absolute top-4 right-4 py-1 px-2"
            onClick={() => setShowHoraDisponibilidade(false)}
          >
            <i className="fas fa-times" />
          </Button>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col xs={6}>
              <TimePickerMaskedInput
                title="Hora Início"
                label="Hora Início"
                invalidMessage={validationErrors.horaInicio}
                selected={newOrUpdateHoraInicio}
                onChange={(date) => setNewOrUpdateHoraInicio(date)}
              />
            </Col>
            <Col xs={6}>
              <TimePickerMaskedInput
                title="Hora Término"
                label="Hora Término"
                invalidMessage={validationErrors.horaTermino}
                selected={newOrUpdateHoraTermino}
                onChange={(date) => setNewOrUpdateHoraTermino(date)}
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={handleUpdateDisponibilidade}
            block
          >
            Alterar
          </Button>
        </ModalFooter>
      </Modal>
      <Modal
        isOpen={showDisponibilidade}
        toggle={() => setShowDisponibilidade(!showDisponibilidade)}
        size="lg"
        centered
      >
        <ModalHeader>
          <strong>{`Disponibilidade da Sala de Atendimento ${nome}`}</strong>
          <Button
            className="close position-absolute top-4 right-4 py-1 px-2"
            onClick={() => setShowDisponibilidade(false)}
          >
            <i className="fas fa-times" />
          </Button>
        </ModalHeader>
        <ModalBody>
          <Row className="mb-3">
            <Col>
              <Card className="shadow">
                <CardBody>
                  <Row>
                    <Col>
                      <strong>Alterar horários por período</strong>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={6}>
                      <DatePickerMaskedInput
                        label="Data de"
                        placeholderText="Data de"
                        selected={dataInicio}
                        invalidMessage={validationErrors.dataInicio}
                        onChange={(date) => setDataInicio(date)}
                      />
                    </Col>
                    <Col xs={6}>
                      <DatePickerMaskedInput
                        label="Data até"
                        placeholderText="Data até"
                        selected={dataTermino}
                        invalidMessage={validationErrors.dataTermino}
                        onChange={(date) => setDataTermino(date)}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={6}>
                      <TimePickerMaskedInput
                        title="Hora Início"
                        label="Hora Início"
                        invalidMessage={validationErrors.horaInicio}
                        selected={horaInicio}
                        onChange={(date) => setHoraInicio(date)}
                      />
                    </Col>
                    <Col xs={6}>
                      <TimePickerMaskedInput
                        title="Hora Término"
                        label="Hora Término"
                        invalidMessage={validationErrors.horaTermino}
                        selected={horaTermino}
                        onChange={(date) => setHoraTermino(date)}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Button
                        color="primary"
                        onClick={handleUpdateDisponibilidadeByPeriod}
                        disabled={isLoteUpdating || (!dataInicio && !dataTermino && !horaInicio && !horaTermino)}
                        block
                      >
                        Alterar horários
                      </Button>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Calendar
            selectedDates={[]}
            renderDayContents={renderDayContents}
            yearsRange={range(2000, getYear(new Date()) + 100, 1)}
            onDaysOfCalendarChange={(dates) => setDaysOfCalendar(dates)}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={() => setShowDisponibilidade(false)}>
            Fechar
          </Button>
        </ModalFooter>
      </Modal>
      <Modal
        isOpen={showModal}
        toggle={() => setShowModal(!showModal)}
        size="lg"
        centered
      >
        <ModalHeader>
          <strong>Sala de Atendimento</strong>
          <Button
            className="close position-absolute top-4 right-4 py-1 px-2"
            onClick={() => setShowModal(false)}
          >
            <i className="fas fa-times" />
          </Button>
        </ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup>
              <Input
                type="text"
                placeholder="Nome"
                value={nome}
                invalid={!!validationErrors.nome}
                onChange={({ target: { value } }) => setNome(value)}
              />
              <FormFeedback>{validationErrors.nome}</FormFeedback>
            </FormGroup>
            <FormGroup>
              <Input
                type="number"
                placeholder="Quantidade de Vagas"
                value={quantidadeVagas}
                invalid={!!validationErrors.quantidadeVagas}
                onChange={({ target: { value } }) => setQuantidadeVagas(value)}
              />
              <FormFeedback>{validationErrors.quantidadeVagas}</FormFeedback>
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={handleSave}>Salvar</Button>
        </ModalFooter>
      </Modal>
      <Modal
        isOpen={showCloseSalaAtendimentoModal}
        toggle={() => setShowCloseSalaAtendimentoModal(!showCloseSalaAtendimentoModal)}
        centered
      >
        <ModalHeader>
          <strong>Fechar Sala de Atendimento por período</strong>
          <Button
            className="close position-absolute top-4 right-4 py-1 px-2"
            onClick={() => setShowCloseSalaAtendimentoModal(false)}
          >
            <i className="fas fa-times" />
          </Button>
        </ModalHeader>
        <ModalBody>
          <Form>
            <Row>
              <Col xs={6}>
                <DatePickerMaskedInput
                  label="Data de"
                  placeholderText="Data de"
                  selected={dataCloseSalaAtendimentoInicio}
                  invalidMessage={validationErrors.dataCloseSalaAtendimentoInicio}
                  onChange={(date) => setDataCloseSalaAtendimentoInicio(date)}
                />
              </Col>
              <Col xs={6}>
                <DatePickerMaskedInput
                  label="Data até"
                  placeholderText="Data até"
                  selected={dataCloseSalaAtendimentoTermino}
                  invalidMessage={validationErrors.dataCloseSalaAtendimentoTermino}
                  onChange={(date) => setDataCloseSalaAtendimentoTermino(date)}
                />
              </Col>
            </Row>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={handleCloseSalaAtendimento}>Fechar Salas nesse período</Button>
        </ModalFooter>
      </Modal>
      <Modal
        isOpen={showLoteProgressModal}
        toggle={() => {
          if (!isLoteUpdating) {
            setShowLoteProgressModal(false);
          }
        }}
        centered
        size="lg"
      >
        <ModalHeader>
          <strong>Alteração de horários por período</strong>
          <Button
            className="close position-absolute top-4 right-4 py-1 px-2"
            disabled={isLoteUpdating}
            onClick={() => {
              if (!isLoteUpdating) {
                setShowLoteProgressModal(false);
              }
            }}
          >
            <i className="fas fa-times" />
          </Button>
        </ModalHeader>
        <ModalBody>
          {isLoteUpdating && !loteProgress ? (
            <div className="text-center py-4">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Carregando...</span>
              </div>
              <p className="mt-3 mb-0">Iniciando alteração dos horários...</p>
            </div>
          ) : loteProgress ? (
            <div>
              <Row className="mb-3">
                <Col>
                  <div className="d-flex align-items-center">
                    <i className={`fa-solid fa-circle mr-2 ${loteProgress.status === 'error' ? 'text-danger' : (isLoteUpdating || loteProgress.status === 'progress' ? 'text-warning' : 'text-success')}`} />
                    <strong>
                      {loteProgress.status === 'error'
                        ? (loteProgress.message || 'Falha ao alterar os horários')
                        : (isLoteUpdating || loteProgress.status === 'progress'
                          ? (loteProgress.message || 'Alteração em andamento...')
                          : 'Alteração concluída!')}
                    </strong>
                  </div>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col xs={4}>
                  <Card color="dark" className="text-center">
                    <CardBody>
                      <h5 className="text-white">{loteProgress.total || 0}</h5>
                      <small className="text-white">Encontrados</small>
                    </CardBody>
                  </Card>
                </Col>
                <Col xs={4}>
                  <Card color="success" className="text-center">
                    <CardBody>
                      <h5 className="text-white">{loteProgress.updated || 0}</h5>
                      <small className="text-white">Atualizados</small>
                    </CardBody>
                  </Card>
                </Col>
                <Col xs={4}>
                  <Card color="warning" className="text-center">
                    <CardBody>
                      <h5 className="text-white">{loteProgress.skipped || 0}</h5>
                      <small className="text-white">Ignorados</small>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              {!isLoteUpdating && loteProgress.status !== 'progress' && loteProgress.skipped > 0 && (
                <>
                  <Row className="mb-3">
                    <Col>
                      <p className="mb-2 text-muted">
                        Horários do período fechado das salas não são alterados.
                      </p>
                      <Button
                        color="link"
                        className="p-0 text-decoration-none"
                        onClick={() => setShowSkippedDetails((prev) => !prev)}
                      >
                        <i className={`fa-solid fa-chevron-${showSkippedDetails ? 'up' : 'down'} mr-2`} />
                        Ver datas ignoradas
                      </Button>
                    </Col>
                  </Row>
                  <Collapse isOpen={showSkippedDetails}>
                    <Row className="mb-3">
                      <Col>
                        <Card>
                          <CardBody className="py-2" style={{ maxHeight: '220px', overflowY: 'auto' }}>
                            {(loteProgress.skippedItems || []).map((item) => (
                              <div key={`${item.reason}-${item.dataHoraInicio}`} className="d-flex justify-content-between py-1 border-bottom">
                                <span>
                                  {item.dataHoraInicio
                                    ? format(new Date(item.dataHoraInicio), 'dd/MM/yyyy', { locale: ptBR })
                                    : 'Data não informada'}
                                </span>
                                <span className="text-muted">
                                  Período fechado
                                </span>
                              </div>
                            ))}
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </Collapse>
                </>
              )}
              {(isLoteUpdating || loteProgress.status === 'progress') && (
                <Row className="mt-3">
                  <Col>
                    <div className="progress">
                      <div
                        className="progress-bar progress-bar-striped progress-bar-animated"
                        role="progressbar"
                        style={{ width: '100%' }}
                      >
                        Processando...
                      </div>
                    </div>
                  </Col>
                </Row>
              )}
            </div>
          ) : null}
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={() => setShowLoteProgressModal(false)}
            disabled={isLoteUpdating}
          >
            {isLoteUpdating ? 'Atualizando...' : 'Fechar'}
          </Button>
        </ModalFooter>
      </Modal>
    </Container>
  );
}

export default SalaAtendimentos;
